import styles from './EventBanner.module.scss';
import { track } from '@amplitude/analytics-browser';
import classNames from 'classnames';

const EVENT_LINK = 'https://postprime.com/PostPrime?tab=posts';
const EventBanner = ({ className }: { className?: string }) => {
  const bgUrl = '/images/banners/2025-07-12-event.png';
  return (
    <div
      className={classNames(styles.banner, className ?? '')}
      onClick={() => {
        track('Click Top Banner', { banner_type: 'event_banner' });
        window.open(EVENT_LINK, '_blank')?.focus();
      }}
    >
      <img src={bgUrl} width="100%" />
    </div>
  );
};

export default EventBanner;
